
import { useNavigate } from 'react-router-dom';
import type { NewsApiArticle } from '../../services/newsApi';

interface ApiNewsCardProps {
  article: NewsApiArticle;
}

export default function ApiNewsCard({ article }: ApiNewsCardProps) {
  const navigate = useNavigate();


  const formatDate = (dateString: string): string => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    } catch {
      return dateString;
    }
  };

  const handleReadMore = () => {
    // Navegar a la página de detalle de la API
    navigate(`/api-news/${encodeURIComponent(article.article_id)}`);
  };

  const author = article.creator && article.creator.length > 0 ? article.creator[0] : 'Autor desconocido';
  const description = article.description || 'Descripción no disponible';
  const source = article.source_id || 'Fuente externa';

  // Usar la imagen de la noticia original si está disponible, sino usar placeholder
  const articleImage = article.image_url || `https://readdy.ai/api/search-image?query=vintage%20newspaper%20article%20thumbnail%2C%20sepia%20tones%2C%20aged%20paper%20texture%2C%20literary%20news%20image%2C%20classic%20journalism%20photo%2C%20antique%20press%20illustration%2C%20brown%20vintage%20colors%2C%20old%20media%20photograph&width=40&height=40&seq=default_news_${article.article_id}&orientation=squarish`;

  return (
    <div className="vintage-paper aged-paper p-4 shadow-lg relative z-10">
      <div className="flex justify-between items-start mb-3">
        <div className="absolute top-3 left-3 w-10 h-10 vintage-paper-subtle rounded-[15%] img-vintage-thumb">
          <img 
            src={articleImage}
            alt={`Vista previa de ${article.title}`}
            className="w-full h-full object-cover"
            onError={(e) => {
              // Fallback si la imagen no carga
              e.currentTarget.src = `https://readdy.ai/api/search-image?query=vintage%20newspaper%20article%20thumbnail%2C%20sepia%20tones%2C%20aged%20paper%20texture%2C%20literary%20news%20image%2C%20classic%20journalism%20photo%2C%20antique%20press%20illustration%2C%20brown%20vintage%20colors%2C%20old%20media%20photograph&width=40&height=40&seq=fallback_${article.article_id}&orientation=squarish`;
            }}
          />
        </div>
        <span className="text-xs text-sepia-600 font-ui ml-auto bg-sepia-100/50 px-2 py-1 vintage-paper-subtle">
          {formatDate(article.pubDate)}
        </span>
      </div>
      
      <h3 className="font-headings text-lg text-sepia-900 mb-2 leading-tight mt-6 relative z-10">
        {article.title}
      </h3>
      
      <p className="text-sm text-sepia-700 mb-3 font-body leading-relaxed relative z-10">
        {description.length > 120 ? `${description.substring(0, 120)}...` : description}
      </p>
      
      <div className="flex justify-between items-center text-xs text-sepia-600 mb-3 relative z-10">
        <span className="font-ui">Por: {author}</span>
        <span className="font-ui">{source}</span>
      </div>

      <button 
        onClick={handleReadMore}
        className="w-[40%] vintage-paper-subtle text-sepia-900 hover:bg-sepia-200/70 px-3 py-2 text-sm font-ui transition-all duration-300 rounded-[15%] whitespace-nowrap relative z-10 hover:shadow-md"
      >
        Leer más
      </button>
    </div>
  );
}
